import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import 'react-sliding-pane/dist/react-sliding-pane.css'
import { Layout, PageHeader, UnvButton, UnvModal, Icon } from 'components'
import StatementForm from 'components/Forms/StatementForm/StatementForm'
import styles from './StatementPage.module.scss'
import StatementTable from './components/StatementTable/StatementTable'

import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useReactToPrint } from 'react-to-print'
import EmployeeRoleSelect from 'hooks/EmployeeSelect/EmployeeRoleSelect'
import EmployeeSelectUserId from 'hooks/EmployeeSelect/EmployeeSelectUserId'
import EmployeeStatusSelect from 'hooks/EmployeeSelect/EmployeeStatusSelect'
import EmployeeTypeSelect from 'hooks/EmployeeSelect/EmployeeTypeSelect'
import { RequestReportStatement } from 'service/StatementsService'
import SlidingPaneUtil from 'utils/SlidingPaneUtil'
import userInfo from 'utils/userInfo'
import StatementReportTable from './components/StatementTable/StatementReportTable'

function StatementPage() {
  const { t } = useTranslation('common')
  const [width, setWidth] = useState(window.innerWidth)
  const [filterChoose, setFilterChoose] = useState(6)
  const [selectedFilter, setSelectedFilter] = useState('')
  const [render, setRender] = useState(false)
  const [SearchByTitle, setSearchByTitle] = useState()
  const [searchTerm, setSearchTerm] = useState()

  const [openModal, setOpenModal] = useState(false)
  const [selectedEmployee, setSelectedEmployee] = useState('')
  const [selectedEmployeeLabel, setSelectedEmployeeLabel] = useState([])
  const [selectedRole, setSelectedRole] = useState([])
  const [selectedRoleLabel, setSelectedRoleLabel] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('')
  const [selectedType, setSelectedType] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [responseInfo, setResponseInfo] = useState(null)

  const componentRef = useRef()
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Simpleraport',
  })

  const handleSubmitReport = async () => {
    try {
      let response = await RequestReportStatement({
        employees: selectedEmployee,
        roles: selectedRole,
        type_doc: selectedType,
        statuses: selectedStatus.includes('Все') ? [] : selectedStatus,
        startDate: startDate,
        endDate: endDate,
      })

      setResponseInfo([...response.data.STATEMENT])
      setOpenModal(false)
    } catch (error) {

      setOpenModal(false)
    }
  }

  const handleSearch = (event) => {
    setSearchTerm(event.target.value)
  }
  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  })

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [width])
  useEffect(() => {
    width < 600 && handleSideNavToggle()
  })

  function handleSideNavToggle() {}

  const user = userInfo()
  const navigate = useNavigate()

  useEffect(() => {
    setRender(false)
  }, [render])

  const allStatements = useSelector((state) => state.statement)
  const [idSearch, setIdSearch] = useState(1)
  const [typeSearch, setTypeSearch] = useState('')
  const filter = [
    { id: 1, label: t('statements.page.filter_by_name') },
    { id: 2, label: t('statements.page.filter_by_responsible') },
  ]

  const headerActions = (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      <UnvButton variant="primary" iconLeft="plus" onClick={() => setState({ isPaneOpen: true })}>
        {t('common.create')}
      </UnvButton>
      <UnvButton variant="secondary" iconLeft="document" onClick={() => setOpenModal(true)}>
        {t('statements.page.create_report')}
      </UnvButton>
    </div>
  )

  return (
    <Layout>
      {responseInfo === null ? (
        <div className={styles.wrapper}>
          <PageHeader
            icon={<Icon name="file-text" size={28} />}
            title={t('auto.statementpage.title', 'Заявления')}
            subtitle={t('auto.statementpage.subtitle', 'Входящие, исходящие, история заявлений')}
            actions={headerActions}
          />
          <div className={styles.titile__wrapper}>
            <div style={{display: 'flex',alignItems: 'center',marginLeft: '10px', fontSize: '18px', fontWeight: '400'}}>
            <div style={{ display: 'flex', justifyContent: 'space-between'  }} >

            {width < 1000 ? (<select
              style={{padding: '0', }}
              className={styles.title}
              value={filterChoose}
              onChange={(e) => setFilterChoose(parseInt(e.target.value))}
            >
              <option value={6}>{t('statements.menu.incoming')}</option>
              <option value={4}>{t('statements.page.outgoing')}</option>
              <option value={5}>{t('statements.menu.history')}</option>
            </select> ) : (<div style={{ display: 'flex', gap: '15px', marginTop: '3px' }}>
                <p
                  onClick={(e) => setFilterChoose(parseInt(6))}
                  className={filterChoose === 6  ? styles.active : styles.menu_items}
                  value={6}
                >
                  {t('statements.menu.incoming')}
                </p>
                <p
                  onClick={(e) => setFilterChoose(parseInt(4))}
                  className={filterChoose === 4  ? styles.active : styles.menu_items}
                  value={4}
                >
                  {t('statements.page.outgoing')}
                </p>
                <p
                  onClick={(e) => setFilterChoose(parseInt(5))}
                  className={filterChoose === 5 ? styles.active : styles.menu_items}
                  value={5}
                >
                  {t('statements.menu.history')}
                </p>

              </div>)}
            </div>
            </div>
            <>
              {width > 1000 ? (
                <SlidingPaneUtil
                  size="50%"
                  title={t('statements.page.new_appeal')}
                  state={state}
                  setState={setState}
                >
                  <StatementForm setRender={setRender} setState={setState} />{" "}
                </SlidingPaneUtil>
              ) : (
                <SlidingPaneUtil
                  size="100%"
                  title={t('statements.page.new_appeal')}
                  state={state}
                  setState={setState}
                >
                  <StatementForm setRender={setRender} setState={setState} />{" "}
                </SlidingPaneUtil>
              )}
            </>
          </div>

          <StatementTable
            render={render}
            filterChoose={filterChoose}
            setRender={setRender}
            setFilterChoose={setFilterChoose}
            searchTerm={searchTerm}
            SearchByTitle={SearchByTitle}
          />
        </div>
      ) : (
        <div className={styles.wrapper}>
          <style>
            {`
      @media print {
        /* Стили, применяемые при печати */
        body {
          background-color: white;
          font-size: 12pt;
 
        }
        /* Пример стилизации элементов при печати */
        .print-only {
          padding: 15px;
          color: white;
        }
        /* Стилизация элемента h4 при печати */
        .print-only h4 {
          color: black !important;
        }
      }
    `}
          </style>
          <PageHeader
            icon={<Icon name="file-text" size={28} />}
            title={t('auto.statementpage.report_title', 'Отчёт по заявлениям')}
            actions={
              <div style={{ display: 'flex', gap: 8 }}>
                <UnvButton variant="ghost" iconLeft="arrow-left" onClick={() => navigate(-1)}>{t('common.back')}</UnvButton>
                <UnvButton variant="primary" iconLeft="document" onClick={handlePrint}>{t('common.print')}</UnvButton>
              </div>
            }
          />
          <div className="print-only" ref={componentRef}>
            <h4
              style={{
                color: 'black',
                paddingLeft: '15px',
                paddingTop: '15px',
              }}
            >
              {t('tasks.selected_employees')}{' '}
              {selectedEmployeeLabel &&
                selectedEmployeeLabel.map((item) => (
                  <span style={{ paddingLeft: '4px' }}>{item}</span>
                ))}
            </h4>
            <h4 style={{ color: 'black', paddingLeft: '15px' }}>
              {t('statements.page.selected_role')}: {selectedRole}
            </h4>
            <h4 style={{ color: 'black', paddingLeft: '15px' }}>
              {t('statements.page.selected_type')}:{' '}
              {selectedType &&
                selectedType.map((item) => (
                  <span style={{ paddingLeft: '4px' }}>{item}</span>
                ))}
            </h4>

            <h4 style={{ color: 'black', paddingLeft: '15px' }}>
              {t('tasks.selected_status')} {selectedStatus}
            </h4>
            <h4 style={{ color: 'black', paddingLeft: '15px' }}>
              {t('tasks.start')} {startDate}
            </h4>
            <h4
              style={{
                paddingBottom: '10px',
                color: 'black',
                paddingLeft: '15px',
              }}
            >
              {t('tasks.end')} {endDate}
            </h4>
            <StatementReportTable data={responseInfo} />
          </div>
        </div>
      )}

      <UnvModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title={t('statements.page.create_report')}
        size="md"
      >
        <div
          className={styles.modal_report__wrapper}
          style={{ gap: '16px', flexDirection: 'column', display: 'flex' }}
        >
          {user?.is_admin_of ? (
            <EmployeeSelectUserId
              selectedEmployee={setSelectedEmployee}
              setSelectedEmployeeLabel={setSelectedEmployeeLabel}
              service={'document'}
              isMulti={true}
            />
          ) : (
            ''
          )}
          <EmployeeRoleSelect
            isStatement={true}
            setSelectedRole={setSelectedRole}
            isMulti={false}
          />
          <EmployeeTypeSelect
            setSelectedType={setSelectedType}
            isMulti={true}
          />
          <EmployeeStatusSelect
            setSelectedStatus={setSelectedStatus}
            isMulti={true}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '5px',
                width: '48%',
              }}
            >
              <h4>{t('tasks.from')} </h4>
              <input
                type="date"
                onChange={(e) => setStartDate(e.target.value)}
                name="start"
                required
                className={styles.discription_input}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '5px',
                width: '48%',
              }}
            >
              <h4>{t('tasks.to')}</h4>
              <input
                type="date"
                onChange={(e) => setEndDate(e.target.value)}
                name="end"
                required
                className={styles.discription_input}
              />
            </div>
          </div>

        </div>
        <UnvModal.Footer>
          <UnvButton variant="ghost" onClick={() => setOpenModal(false)}>{t('common.close')}</UnvButton>
          <UnvButton variant="primary" iconLeft="check" onClick={handleSubmitReport}>{t('common.create')}</UnvButton>
        </UnvModal.Footer>
      </UnvModal>
    </Layout>
  )
}

export default StatementPage
